// Remembers, per user and browser, the newest What's New announcement the user has seen, so the
// sidebar can show a dot when there is a newer one. There is no read state on the API.

import { WHATS_NEW_LAST_SEEN_KEY } from './seenStorageKeys';

const SEEN_EVENT = 'whats-new-seen';

const storageKey = (userId: string) => `${WHATS_NEW_LAST_SEEN_KEY}:${userId}`;

export function readWhatsNewLastSeen(userId: string): string | null {
  try {
    return localStorage.getItem(storageKey(userId));
  } catch {
    return null;
  }
}

export function markWhatsNewSeen(userId: string, seenAt: string): void {
  try {
    localStorage.setItem(storageKey(userId), seenAt);
  } catch {
    return;
  }

  window.dispatchEvent(new Event(SEEN_EVENT));
}

export function subscribeToWhatsNewSeen(onChange: () => void): () => void {
  window.addEventListener(SEEN_EVENT, onChange);
  // Another tab marking the announcements seen clears the dot here too.
  window.addEventListener('storage', onChange);

  return () => {
    window.removeEventListener(SEEN_EVENT, onChange);
    window.removeEventListener('storage', onChange);
  };
}
